import React, { useState } from 'react'
import Gadjet from '../../images/gadjet.svg'
import SearchNot from '../../images/searchNot.png'
import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import ReportIcon from '@mui/icons-material/Report';
import FemaleIcon from '@mui/icons-material/Female';
import {  ArrowBack, ArrowForward, CycloneOutlined, DateRange, Sell, SensorDoor, Sensors } from '@mui/icons-material'
import { useGlobalContext } from '../Context';
import CattleHistoryCompare from '../HistoryCompare/CattleHistoryCompare';
import useHistory from '../CustomHooks/useHistory';
import EmptyReturn from '../EmptyReturn'
const moment=require('moment-jalaali')

const CattleHistoryParameterCard = ({data}) => {
  const {isOpenModal,closeModalls,openModalls}=useGlobalContext();
  const [SData,setSdata]=useState('')
  return (
    <Container className='allCardsCon'>
     <Row style={{width:'100%'}}>
     {
        data?.length?data.map((item,index)=>{
            const {entryDate}=item;
                    const birth=entryDate?.substring(0,10);
                    const pbirth=moment(birth).format('jYYYY-jMM-jDD')
            return <div key={index} style={{display:'flex', flexWrap:'wrap',gap:'4px'}} className='  col-sm-12 col-md-6 col-lg-4 col-xl-3 col-xxl-3 gap-3'>
                <div  className='ThemeCard' style={{borderRight:'2px solid #7FB020'}}>
            <div className='ThemeCardItem '>
            <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div>
                <span>شماره گوش :</span>
                <span>{JSON.parse(item?.newJson)?.EarTagNumber}</span>
            </div>
            <div className='ThemeCardItem '>
            <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div>
                <span> شماره بدن :</span>
                <span>{JSON.parse(item?.newJson)?.BodyNumber}</span>
            </div>
            <div className='ThemeCardItem '>
            <div className='LogoFormT'><div><span>
            <img style={{width:'20px',height:'20px'}} src={Gadjet}/>
                </span>
                    </div></div>
                <span> شماره گردنبند :</span>
                <span>{JSON.parse(item?.newJson)?.NecklaceNumber?JSON.parse(item?.newJson)?.NecklaceNumber:'---'}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <Sensors/>
                </span>
                    </div></div>
                <span>شماره سنسور :</span>
                <span>{JSON.parse(item?.newJson)?.Sensor?.DeviceCode}</span>
            </div>
            
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                <span>تاریخ  :</span>
                <span>{pbirth}</span>
            </div>
            <div  onClick={()=>{
                      setSdata(item);openModalls()
                    }} className='btnCardDAm'>مشاهده</div>
          </div>
            </div>
        })
     :<EmptyReturn/>}
     </Row>
     {isOpenModal&&<CattleHistoryCompare data={SData?.currentJson} data2={SData?.newJson}/>}
    </Container>
  )
}

export default CattleHistoryParameterCard
